// components/ProtectedAnonRoute.js
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { signInAnon } from "../services/firebaseAuthService";

let hasTriedAnon = false; // Prevent multiple anonymous sign-ins

const ProtectedAnonRoute = ({ children }) => {
  const { currentUser } = useAuth();
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if (currentUser) {
      setIsReady(true);
      return;
    }

    const tryAnonSignIn = async () => {
      if (hasTriedAnon) return;
      hasTriedAnon = true;

      try {
        await signInAnon(); // Attempt anonymous sign-in
      } catch (err) {
        console.error("Anonymous sign-in failed:", err);
      } finally {
        setIsReady(true); // Ensure rendering continues
      }
    };

    tryAnonSignIn();
  }, [currentUser]);

  if (!isReady) return null; // Avoid rendering before the anonymous sign-in attempt

  return children;
};

export default ProtectedAnonRoute;
